'use client'
import { Tooltip as TooltipUI, TooltipContent, TooltipProvider, TooltipTrigger } from '@/ui'

interface TooltipProps {
  content: string
  children: React.ReactNode
}

const Tooltip: React.FC<TooltipProps> = ({ content, children }) => {
  return (
    <TooltipProvider>
      <TooltipUI>
        <TooltipTrigger>{children}</TooltipTrigger>
        <TooltipContent className="max-w-[300px] rounded-md border border-gray-2 bg-white p-4 text-sm text-black shadow-[0px_8px_8px_-8px_rgba(0,0,0,0.1)]">
          <p>{content}</p>
        </TooltipContent>
      </TooltipUI>
    </TooltipProvider>
  )
}

export default Tooltip
